import React from 'react';

export const FBIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0,0,256,256"
    width="24px"
    height="24px"
  >
    <g transform="translate(-20.48,-20.48) scale(1.16,1.16)">
      <g transform="scale(5.33333,5.33333)">
        <path
          d="M24,5c-10.49341,0 -19,8.50659 -19,19c0,10.49341 8.50659,19 19,19c10.49341,0 19,-8.50659 19,-19c0,-10.49341 -8.50659,-19 -19,-19z"
          fill="#1977f2"
        ></path>
        <path
          d="M26.572,29.036h4.917l0.772,-4.995h-5.69v-2.73c0,-2.075 0.678,-3.915 2.619,-3.915h3.119v-4.359c-0.548,-0.074 -1.707,-0.236 -3.897,-0.236c-4.573,0 -7.254,2.415 -7.254,7.917v3.323h-4.701v4.995h4.701v13.729c0.931,0.14 1.874,0.235 2.842,0.235c0.875,0 1.729,-0.08 2.572,-0.194z"
          fill="#ffffff"
        ></path>
      </g>
    </g>
  </svg>
);
